//   power: [],
import { FilterFormFieldStrategyType } from "@/common/types";
import rackSizeOptions from "../filter-options/rackSize.options";

const rackAndSpaceFilterByProduct: FilterFormFieldStrategyType[] = [
  {
    key: "Rack Size",
    element: {
      inputType: "checkboxGroup",
      label: "Rack Size",
      name: "DcServiceSpaceAndRack-rackSize",
      required: false,
      options: rackSizeOptions,
    },
  },
  {
    key: "Space Size",
    element: {
      inputType: "range",
      label: "Space Size",
      name: "DcServiceSpaceAndRack-spaceSize",
      required: false,
      rangeMin: 0,
      rangeMax: 100,
    },
  },
];
export default rackAndSpaceFilterByProduct;
